/* eslint-disable import/prefer-default-export */
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getVirtualCoupons } from '@/api/fuli';
import { marketDistribute } from '@/api/card';
import { env, Native } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import { jumpWx } from '@/pages/mall/common/utils/jumpUrl';
import { channelJump } from '@hb/generate-income-components';
import { getTokenAndKey, getTokenAndLocation } from '../../utils';
import {
  CARD_COUPON_TYPE,
  COUPON_STATUS,
  PART_STATUS,
  TIME_COUPON_STATUS,
} from './consts';
import { MARKET_OFFER_TYPE } from '../../const';
import { getSystemCode } from '../mall/common/env/env';

let lastTime = null;

// 列表
export const getExchangeList = (mapper) => async function anonymous() {
  if (this.loading || !this.hasMore[this.active]) {
    return Promise.resolve();
  }
  if (lastTime && Date.now() - this.lastTime < 100) {
    return Promise.resolve();
  }
  lastTime = Date.now();
  this.loading = true;
  const cur = this.active;
  const { type: businessId, pageNum } = this.current;
  const { token, adCode, cityCode } = await getTokenAndLocation();
  let showChannelId;
  if (env.isEasyBikeApp) {
    showChannelId = '1';
  } else if (env.isAliMP || env.isAliMPMonitor) {
    showChannelId = '2';
  }
  return getVirtualCoupons({
    token,
    businessId,
    pageSize: this.pageSize,
    pageNum: pageNum || 1,
    showChannelId,
    adCode,
    cityCode,
    includeOption: {
      includePromo: true,
      includeUserLimit: false,
    },
  })
    .then((v) => {
      if (v && v.data) {
        if (v.pageCount <= (pageNum || 1)) {
          this.$set(this.hasMore, this.active, false);
        }
        this.$set(this.pageNums, cur, pageNum + 1);
        this.$set(
          this.info,
          cur,
          (this.info[cur] || []).concat(v.data.map(mapper)),
        );
      } else {
        this.$set(this.hasMore, this.active, false);
      }
    })
    .catch((e) => {
      Toast.showError(e);
      this.$set(this.hasMore, this.active, false);
    })
    .then(() => {
      this.loading = false;
    });
};

const getCardPriceText = (cardAwardDTO) => {
  const { days, times } = cardAwardDTO;
  return times
    ? `${times}次`
    : `${days ? `${days}天` : ''}${times ? `${times}次` : ''}`;
};

const getItemPricePairs = (item) => {
  if (!item) {
    return [];
  }
  const { offerType, worth, cardAwardDTO } = item;
  const v = [];
  if (offerType === MARKET_OFFER_TYPE.CARD && cardAwardDTO) {
    const { days, times } = cardAwardDTO;
    if (times) {
      v.push({ unit: '次', value: times });
    }
    if (days) {
      v.push({ unit: '天', value: days });
    }
  } else {
    v.push({ unit: '元', value: worth });
  }
  return v;
};

export function handleMarketCoupons(coupons, options = {}) {
  try {
    const {
      periodStatus, time, type, sku, newModule,
    } = options;

    return coupons
      .filter((v) => {
        if (
          [MARKET_OFFER_TYPE.COUPON, MARKET_OFFER_TYPE.CARD].indexOf(
            v.offerType,
          ) === -1
        ) {
          return false;
        }
        return sku ? v && v.receiveStatus !== COUPON_STATUS.NO_SKU : true;
      })
      .map((v) => {
        const {
          propertyName,
          prizeName,
          worth,
          receiveStatus,
          description,
          subtitle,
          usePort,
          comments,
          totalNum,
          totalReceived,
          swellPrizeDetail,
          cardAwardDTO,
          offerType,
        } = v;
        const one = {
          type,
          title: propertyName || prizeName,
          subtitle: comments || description || subtitle,
          percentage: ((totalReceived / totalNum) * 100).toFixed(0), // 抢券进度
          detail: v,
          time,
          offerType,
          newModule,
          cardAwardDTO: cardAwardDTO || {},
          swellPrice:
            swellPrizeDetail
            && (swellPrizeDetail.worth ? String(swellPrizeDetail.worth) : ''),
        };
        one.currentPrice = (() => {
          if (offerType === MARKET_OFFER_TYPE.CARD && cardAwardDTO) {
            return getCardPriceText(cardAwardDTO);
          }
          return worth ? String(worth) : '';
        })();
        one.currentPriceV2 = getItemPricePairs(v);
        one.swellPriceV2 = getItemPricePairs(swellPrizeDetail);
        if (swellPrizeDetail) {
          one.swellOfferType = swellPrizeDetail.offerType;
          if (swellPrizeDetail.offerType === MARKET_OFFER_TYPE.CARD) {
            one.swellPrice = getCardPriceText(swellPrizeDetail.cardAwardDTO);
            one.swellCardDTO = swellPrizeDetail.cardAwardDTO;
          }
        }
        const transfer = {
          [COUPON_STATUS.GO_SWELL_OR_USE]: '2',
          [COUPON_STATUS.HAS_RECEIVED]: '1',
          [COUPON_STATUS.HAS_SWELL]: '3',
          [COUPON_STATUS.NOT_RECEIVED]: '0',
          [COUPON_STATUS.NO_SKU]: '4',
        };
        if (type !== CARD_COUPON_TYPE.TIME_COUPON) {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'coupon_state',
            contentId: 'coupon_state',
            exposureTimes: 1,
            businessInfo: {
              coupon_state: transfer[receiveStatus] || '未知',
              Sessions: time,
              coupon_name: one.title,
              activity: type === CARD_COUPON_TYPE.TIME_COUPON ? '0' : '1',
            },
          });
        }
        if (usePort && usePort.length === 1 && usePort[0] === 1) {
          one.corner = 'APP专享';
        }
        if (receiveStatus === COUPON_STATUS.GO_SWELL_OR_USE) {
          if (newModule) {
            one.corner = '';
          } else {
            one.corner = '可膨胀';
          }
          one.status = TIME_COUPON_STATUS.DOUBLE;
          one.btn = '去膨胀';
        } else if (
          receiveStatus === COUPON_STATUS.GO_SWELL
          || receiveStatus === COUPON_STATUS.HAS_SWELL
          || receiveStatus === COUPON_STATUS.HAS_RECEIVED
        ) {
          one.status = receiveStatus === COUPON_STATUS.HAS_RECEIVED
            ? TIME_COUPON_STATUS.GO_USE
            : TIME_COUPON_STATUS.USE;
          one.btn = '去使用';
        } else if (receiveStatus === COUPON_STATUS.NO_SKU) {
          one.status = TIME_COUPON_STATUS.NONE;
          one.btn = '已抢完';
        } else if (receiveStatus === COUPON_STATUS.NOT_RECEIVED) {
          one.status = TIME_COUPON_STATUS.GRAB;
          one.btn = type === CARD_COUPON_TYPE.TIME_COUPON ? '立即抢' : '领券';
        }
        if (periodStatus === PART_STATUS.END) {
          if (
            [
              TIME_COUPON_STATUS.USE,
              TIME_COUPON_STATUS.DOUBLE,
              TIME_COUPON_STATUS.GO_USE,
            ].indexOf(one.status) === -1
          ) {
            one.disabled = true;
          }
        }
        if (offerType === MARKET_OFFER_TYPE.CARD) {
          one.corner = 'APP专享';
        }
        return one;
      });
  } catch (error) {
    // eslint-disable-next-line no-console
    return [];
  }
}

export async function getMarketCoupon(
  { componentKey, activityCode },
  { prizeCode },
) {
  const { token } = await getTokenAndKey();
  return marketDistribute({
    activityCode,
    token,
    channelId: env.platformCode,
    methodName: 'applyPrize',
    param: JSON.stringify({ activityCode, componentKey, prizeCode }),
  });
}

export async function doubleMarketCoupon(
  { componentKey, activityCode },
  { prizeCode },
) {
  const { token } = await getTokenAndKey();
  return marketDistribute({
    activityCode,
    token,
    channelId: env.platformCode,
    methodName: 'applySwellPrize',
    param: JSON.stringify({ activityCode, componentKey, prizeCode }),
  });
}

export async function handleClickCoupon(
  { componentKey, activityCode },
  item,
  options,
) {
  if (item.status === TIME_COUPON_STATUS.GRAB) {
    const { type, time } = options;
    UBT.clickButton({
      pageId: 'Welfare',
      buttonName: 'Scramble_go',
      categoryId: 'platform',
      businessInfo: {
        Sessions: time,
        coupon_name: item.title,
        activity: type === CARD_COUPON_TYPE.TIME_COUPON ? '0' : '1',
      },
    });
    return getMarketCoupon({ componentKey, activityCode }, item.detail)
      .then(() => Toast.show(
        `领取成功，${item.offerType === MARKET_OFFER_TYPE.CARD ? '骑行卡' : '优惠券'
        }已放入您的账户中`,
      ))
      .catch((e) => Toast.showError(e));
  }
  if (item.status === TIME_COUPON_STATUS.DOUBLE) {
    return doubleMarketCoupon(
      { componentKey, activityCode },
      item.detail,
    ).catch((e) => Toast.showError(e));
  }
  return Promise.resolve();
}

export function welfareGo(to) {
  if (env.isAliMP || env.isAliMPMonitor) {
    Native.callNative({
      method: 'goOperationUrlV2',
      params: to,
    });
  } else {
    if (env.isEasyBikeApp) {
      Native.toggleNavBar({ isShow: true }).catch(() => { });
    }
    window.location.href = to;
  }
}

export function welfareGoCoupon() {
  const codeEnv = config.env !== 'pro' ? `/${config.env === 'dev' ? 'fat' : config.env}` : '';
  const systemCode = getSystemCode();
  if (env.isWechatMini) {
    const url = `https://m.hellobike.com/AppHelloBikeEquityH5${codeEnv}/latest/index.html#/coupon?couponTabCode=100&systemCode=${systemCode}&adsource=welfareExchange&needAuthParams=true&auth=1`;
    jumpWx(url);
    return;
  }
  if (env.isAliMP || env.isAliMPMonitor) {
    Native.callNative({
      method: 'goOperationUrlV2',
      params: '/pages/base/coupon/coupon',
    });
  } else {
    window.location.href = 'hellobike://hellobike.com/coupon?bikeType=100';
  }
}

/**
 * 接口原始数据 → ECommerceChannelInfo 映射
 * 与 generate-income-components Cashback.tsx handleChannelData 保持一致
 * @param {Object} raw - bff.component.data 接口返回的单个 item
 * @returns {Object} ECommerceChannelInfo 格式数据
 */
export function adaptChannelData(raw) {
  return {
    channel: raw.businessType,
    actId: raw.notes,
    originUrl: raw.deepLink,
    gridName: raw.gridName,
    subTitle: raw.subTitle,
    imgUrl: raw.midImg,
    bigImg: raw.bigImg,
    link: raw.deepLink,
    cornerMarks: raw.uniqueDesc ? [{ text: raw.uniqueDesc }] : [],
  };
}

/**
 * 渠道跳转（封装 channelJump 调用）
 * @param {Object} item - 渠道数据
 */
export function handleChannelJump(item) {
  channelJump({
    item,
    scene: 'rebateBonus',
  });
}

export { formatDuration } from '@/utils/date';
